import { render, staticRenderFns } from "./IndustryAndAgriculture.vue?vue&type=template&id=616a9b9a"
import script from "./IndustryAndAgriculture.vue?vue&type=script&lang=js"
export * from "./IndustryAndAgriculture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports